import { IonItem } from '@ionic/react';
import classNames from 'classnames';
import { Backup, formatLocalDateTime } from 'model';
import { useGetProfileQuery } from '../api/UserApi';
import styles from './BackupList.module.css';

export interface BackupsListProps {
	backups: Backup<any>[];
	onSelectBackup: (backup: Backup<any>) => void;
}

export interface BackupsListItemProps {
	backup: Backup<any>;
}

export const BackupListItem = ({ backup }: BackupsListItemProps): JSX.Element => {
	const { data: user } = useGetProfileQuery(backup.lastUpdatedBy);
	return (
		<div className={styles.backupItem}>
			<div className={styles.itemUser}>{user?.username}</div>
			<div>{formatLocalDateTime(backup.created)}</div>
		</div>
	);
};

export const BackupsList = ({ backups, onSelectBackup }: BackupsListProps): JSX.Element => {
	return (
		<>
			{backups?.map(backup => (
				<IonItem
					className={classNames('pointer', styles.IonItem)}
					onClick={() => onSelectBackup(backup)}
					key={backup._id}
				>
					<BackupListItem backup={backup} />
				</IonItem>
			))}
		</>
	);
};
